import { render, staticRenderFns } from "./BpmBizBatchSuspendDealModal.vue?vue&type=template&id=45483d05&scoped=true&"
import script from "./BpmBizBatchSuspendDealModal.vue?vue&type=script&lang=js&"
export * from "./BpmBizBatchSuspendDealModal.vue?vue&type=script&lang=js&"
import style0 from "./BpmBizBatchSuspendDealModal.vue?vue&type=style&index=0&id=45483d05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45483d05",
  null
  
)

export default component.exports